export default __webpack_public_path__ + "static/bg-8abebffd0ab30aeb2da4f57a9d977d07.png";